import "./HomeLogo.css";
import logo from "./CoverGig_Logo.png";
function HomeLogo() {
  return <img className="home-logo" src={logo} alt="This is coverGig!" />;
}

export default HomeLogo;
